module.exports = {"closeButtonText":"Vicino","thumbNailAlt":"Immagine di anteprima","next":"Pagina successiva","previous":"Pagina precedente","addNote":"Aggiungi una nota..."}


//////////////////
// WEBPACK FOOTER
// ./translations/it.json
// module id = 27
// module chunks = 0